import { axiosInstance } from '.';
import { IEVMAttribution } from 'src/types';

const getEVMAttributions = async (
  addresses: string[],
): Promise<Record<string, IEVMAttribution>> => {
  const data = {
    type: 'address',
    params: {
      addresses,
      chain: 'ethereum',
    },
    options: {
      limit: 10000,
    },
  };
  const response = await axiosInstance.post(
    `attributions/get_attributions`,
    data,
  );
  return response.data;
};

export const evm = {
  getEVMAttributions,
};
